import React from "react";
import { withStyles } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { CloseIcon } from "icons"
import Button from "storybookComponents/Button"

const styles = () => ({
  root: {
    width: 500,
    background: "white"
  },
  headerStyle: {
    height: 78,
    background: "#26BBED",
    padding: "23px 30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  textStyle: {
    fontSize: 24,
    color: "white",
    marginLeft: 14,
    marginRight: 90
  },
  closeIconStyle: {
    cursor: "pointer"
  },
  buttonStyle: {
    width: 240,
    height: 48,
    textTransform: "none"
  },
  bodyContainer: {
    padding: "24px 19px"
  },
  bottomContainer: {
    marginTop: 24,
    textAlignLast: "right"
  }

})



const ShareContainer = ({ text, icon, open, handleClose, onShareButtonClick, classes, children }) => {
  return (
    <Dialog onClose={handleClose} open={open}>
      <div className={classes.root}>
        <div className={classes.headerStyle}>
          {icon}
          <div className={classes.textStyle}>
            {text}
          </div>
          <div className={classes.closeIconStyle} onClick={handleClose}>
            <CloseIcon stroke="white" />
          </div>
        </div>
        <div className={classes.bodyContainer}>
          {children}
          <div className={classes.bottomContainer}>
            <Button size="md" className={classes.buttonStyle} onClick={onShareButtonClick.bind(this, open)}>{text}</Button>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default withStyles(styles)(ShareContainer)